import { IFeeTable, IVatTable } from '../ITaxesTable';
import { VatCalculatingError } from '../Errors/VatCalculatingError';
import { TaxLoaderError } from '../Errors/TaxLoaderError';
import { ITaxLoader } from './ITaxLoader';
import { CurrentUser } from '../../user/currentUser';
import { getHubApi } from '../../accountServiceApi/getAccountServiceApi';

export class TaxLoader implements ITaxLoader {
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor() {}

    public async getFee(): Promise<IFeeTable | VatCalculatingError> {
        try {
            const currentUser = CurrentUser.getInstance();
            const hubApi = getHubApi();
            const jsonRpcResponse = await hubApi.getFee(window.app.deviceIdentifier, {
                suid: currentUser.getSuid(),
                token: window.app.config.user_auth_token
            });

            console.log('FEE From API Service', jsonRpcResponse);
            return jsonRpcResponse;
        } catch (exception) {
            return new TaxLoaderError(`Exception on getting fee rate: ${exception.message}`);
        }
    }


    public async getVat(): Promise<IVatTable | VatCalculatingError> {
        try {
            const currentUser = CurrentUser.getInstance();
            const hubApi = getHubApi();
            const jsonRpcResponse = await hubApi.getVat(window.app.deviceIdentifier, {
                suid: currentUser.getSuid(),
                token: window.app.config.user_auth_token
            });

            console.log('VAT From API Service', jsonRpcResponse);
            return jsonRpcResponse;
        } catch (exception) {
            return new TaxLoaderError(`Exception on getting VAT rate: ${exception.message}`);
        }
    }
}
